import spriteAnimalHyppo  from '../../assets/img/spriteAnimalHyppo.png';
import spriteAnimalGirafe from '../../assets/img/spriteAnimalGirafe.png';
import spriteAnimaHyene   from '../../assets/img/spriteAnimalHyene.png';
import spriteAnimalRaton  from '../../assets/img/spriteAnimalRaton.png';
import spriteAnimalToucan from '../../assets/img/spriteAnimalToucan.png';
import spriteAnimalCroco  from '../../assets/img/spriteAnimalCroco.png';
import spriteAnimalEscargot  from '../../assets/img/spriteAnimalEscargot.png';
import spriteAnimalElephant  from '../../assets/img/spriteAnimalElephant.png';
import spriteAnimalAutruche  from '../../assets/img/spriteAnimalAutruche.png';
import spriteAnimalCochon  from '../../assets/img/spriteAnimalCochon.png';
import spriteAnimalDodo  from '../../assets/img/spriteAnimalDodo.png';
import spriteAnimalChevre  from '../../assets/img/spriteAnimalChevre.png';

import spriteObstacleWood  from '../../assets/img/spriteObstacleWood.png';
import spriteObstacleIce  from '../../assets/img/spriteObstacleIce.png';

export const animalsAssets = [
    {
        id: 'girafe',
        spriteId: 'spriteAnimalGirafe',
        animId: 'drawnGirafe',
        sprite: spriteAnimalGirafe,
        rarity: 1,
        weight: 1,
        active: true,
    },
    {
        id: 'hyppo',
        spriteId: 'spriteAnimalHyppo',
        animId: 'drawnHyppo',
        sprite: spriteAnimalHyppo,
        rarity: 1,
        weight: 1,
        active: true,
    },
    {
        id: 'hyene',
        spriteId: 'spriteAnimaHyene',
        animId: 'drawnHyene',
        sprite: spriteAnimaHyene,
        rarity: 1,
        weight: 1,
        active: true,
    },
    {
        id: 'raton',
        spriteId: 'spriteAnimalRaton',
        animId: 'drawnRaton',
        sprite: spriteAnimalRaton,
        rarity: 1,
        weight: 1,
        active: true,
    },
    {
        id: 'toucan',
        spriteId: 'spriteAnimaToucan',
        animId: 'drawnToucan',
        sprite: spriteAnimalToucan,
        rarity: 1,
        weight: 1,
        active: true,
    },
    {
        id: 'croco',
        spriteId: 'spriteAnimalCroco',
        animId: 'drawnCroco',
        sprite: spriteAnimalCroco,
        rarity: 1,
        weight: 1,
        active: true,
    },
    {
        id: 'escargot',
        spriteId: 'spriteAnimalEscargot',
        animId: 'drawnEscargot',
        sprite: spriteAnimalEscargot,
        rarity: 1,
        weight: 1,
        active: true,
    },
    {
        id: 'elephant',
        spriteId: 'spriteAnimalElephant',
        animId: 'drawnElephant',
        sprite: spriteAnimalElephant,
        rarity: 1,
        weight: 1,
        active: true,
    },
    {
        id: 'autruche',
        spriteId: 'spriteAnimalAutruche',
        animId: 'drawnAutruche',
        sprite: spriteAnimalAutruche,
        rarity: 1,
        weight: 1,
        active: true,
    },
    {
        id: 'cochon',
        spriteId: 'spriteAnimalCochon',
        animId: 'drawnCochon',
        sprite: spriteAnimalCochon,
        rarity: 1,
        weight: 1,
        active: true,
    },
    {
        id: 'dodo',
        spriteId: 'spriteAnimalDodo',
        animId: 'drawnDodo',
        sprite: spriteAnimalDodo,
        rarity: 1,
        weight: 1,
        active: true,
    },
    {
        id: 'chevre',
        spriteId: 'spriteAnimalChevre',
        animId: 'drawnChevre',
        sprite: spriteAnimalChevre,
        rarity: 1,
        weight: 1,
        active: true,
    },
    {
        id: 'obstacleWood',
        spriteId: 'spriteObstacleWood',
        animId: 'animsood',
        sprite: spriteObstacleWood,
        rarity: -10,
        weight: 1,
        active: true,
    },
    {
        id: 'obstacleIce',
        spriteId: 'spriteObstacleIce',
        animId: 'animIce',
        sprite: spriteObstacleIce,
        rarity: -10,
        weight: 1,
        active: true,
    }
];

export const defaultLoadAnimalAssetConfig = {
    frameWidth: 200,
    frameHeight: 200,
    startFrame: 0,
    endFrame: 2,
};

export const defaultAnimAnimalAssetConfig = {
    frameRate: 6,
    yoyo: true,
    repeat: -1
};
